import React, { useContext, useEffect } from 'react';
import { Switch, Route, useLocation, useHistory } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import ConfigContext from '../contexts/ConfigContext';
import useFacebookApi from '../hooks/useFacebookApi';

import '../../../public/static/stylesheets/fonts.css';
import '../../stylesheets/admin.postcss';

// Components
import { Footer, Admin, VendorDashboard, CateringDashboard, TruckManage, NewTruck, UnsubscribeShiftAvailable, ManageCateringRequest, CustomerCateringRequestDetail, Account, ChangePassword, Error404Page, Error500Page } from './AdminLayout.imports-loadable';
import Meta from './shared/Meta';
import ErrorModal from './shared/ErrorModal';
import RequireVendor from './auth/RequireVendor';
import RequireAdmin from './auth/RequireAdmin';
import RequireUser from './auth/RequireUser';
import RequireCateringUser from './auth/RequireCateringUser';

function Layout() {
  const location = useLocation();
  const history = useHistory();
  const { city_name, facebookAppId } = useContext(ConfigContext);
  const { loadFacebookSDK } = useFacebookApi();

  // Load Facebook SDK (Seattle only)
  useEffect(() => {
    if (city_name === 'Seattle') {
      loadFacebookSDK().catch((error) => {
        console.error('Error loading Facebook SDK:', error);
      });
    }
  }, [facebookAppId, loadFacebookSDK, city_name]);

  let showFooter = false;
  if (!location.pathname.startsWith('/admin') &&
      !location.pathname.startsWith('/catering') &&
      (!location.pathname.startsWith('/vendor') || location.pathname.startsWith('/vendor/truck/new'))) {
    showFooter = true;
  }

  return (
    <div className='admin-layout'>
      <Meta noindex />
      <Helmet>
        <script src='https://js.stripe.com/v3/' async></script>
        { city_name === 'Seattle' && facebookAppId &&
          <script async defer crossOrigin="anonymous" src="https://connect.facebook.net/en_US/sdk.js"></script>
        }
      </Helmet>

      <div className='MainContent'>
        <Switch>
          <Route
            path='/vendor/truck/new'
            render={() => (
              <RequireVendor>
                <NewTruck/>
              </RequireVendor>
            )}
          />
          <Route
            path='/vendor/truck/:id'
            render={() => (
              <RequireVendor>
                <TruckManage/>
              </RequireVendor>
            )}
          />
          <Route
            path='/vendor/unsubscribe-shift-available/'
            render={() => (
              <RequireVendor>
                <UnsubscribeShiftAvailable/>
              </RequireVendor>
            )}
          />
          <Route
            path='/vendor/'
            render={() => (
              <RequireVendor>
                <VendorDashboard/>
              </RequireVendor>
            )}
          />
          <Route
            path='/welcome'
            render={() => (
              <RequireUser>
                <Account/>
              </RequireUser>
            )}
          />
          <Route
            path='/admin'
            render={() => (
              <RequireAdmin>
                <Admin/>
              </RequireAdmin>
            )}
          />
          <Route
            path='/catering/dashboard'
            render={() => (
              <RequireCateringUser>
                <CateringDashboard/>
              </RequireCateringUser>
            )}
          />
          <Route
            path='/catering/requests/new/:step?'
            render={() => (
              <RequireCateringUser>
                <ManageCateringRequest/>
              </RequireCateringUser>
            )}
          />
          <Route
            path='/catering/requests/:request_id/edit/:step?'
            render={() => (
              <RequireCateringUser>
                <ManageCateringRequest/>
              </RequireCateringUser>
            )}
          />
          <Route
            path='/catering/requests/:request_id'
            exact
            render={() => (
              <RequireCateringUser>
                <CustomerCateringRequestDetail/>
              </RequireCateringUser>
            )}
          />
          <Route
            path='/change-password/'
            render={() => (
              <RequireUser>
                <ChangePassword />
              </RequireUser>
            )}
          />
          <Route
            path='/account/'
            render={() => (
              <RequireUser>
                <Account />
              </RequireUser>
            )}
          />
          <Route
            exact
            path='/error'
            render={() => <Error500Page />}
          />
          <Route
            exact
            path='/not-found'
            render={() => <Error404Page />}
          />
          <Route
            render={() => <Error404Page />}
          />
        </Switch>

        <ErrorModal />
      </div>

      { showFooter &&
        <Footer
          history={history}
        />
      }
    </div>
  );
}

export default Layout;
